import { React, useState, useEffect } from 'react'
import { Navigate, useLocation, useNavigate, useNavigation } from 'react-router-dom';
import { connect, useDispatch } from "react-redux"
import { Link } from 'react-router-dom';
import YourLogo from "../../INVENTORY/Assets/images/yourlogo.png";
import BlueLogo from '../assets/images/blueCoco.png';
import Logo from "../assets/images/pro360.png"
import QLogo from "../assets/images/Qfinitylogos.png"
const LandingHeader = ({ Currency }) => {
    const [headerText, setHeaderText] = useState('Dashboard');
    const location = useLocation();
    const dispatch = useDispatch()
    const navigate = useNavigate()


    const handleIn = () => {
        navigate('/Login')
    }
    return (
        <nav class="navbar navbar-expand-lg  navbar-light bg-light mainBG">
            <div className='container-fluid'>
                <a class="navbar-brand" href="#">
                    {/* <img src={QLogo} /> */}
                    <img src={YourLogo} style={{height:"40px"}}/>
                    {/* <img src={Logo} /> */}
                    {/* <img src={BlueLogo} /> */}
                </a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class=" end">
                    <div class="collapse navbar-collapse end" id="navbarTogglerDemo02">
                        <ul class="navbar-nav me-auto mb-2 mb-lg-0 gap-5 px-lg-5">
                            <li class="nav-item">
                                <a class="nav-link nav-active" aria-current="page" href="#">Home</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/customer/menu">Menu</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href='#'>About</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/Login">Login</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/Login">Inventory</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/Kitchen">Kitchen</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default LandingHeader